import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-white border border-slate-200 rounded-2xl p-5 shadow-sm text-slate-800 space-y-4', className)}
      {...props}
    />
  );
}

/** The small uppercase label + description that opens most studio panels. */
export function SectionHeading({ title, description }: { title: ReactNode; description?: ReactNode }) {
  return (
    <div>
      <h2 className="text-[11px] font-bold text-slate-400 uppercase tracking-wider mb-0.5">{title}</h2>
      {description && <p className="text-xs text-slate-500">{description}</p>}
    </div>
  );
}
